import {initialState} from "./state"

export const setChangelog = (state, payload) => {
  state.changelog = payload
}

export const reset = (state) => {
  const s = initialState()

  Object.keys(s).forEach(key => {
    state[key] = s[key]
  })
}
